// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"519":"31d6cfe0","962":"802eab78"}[chunkId] + ".chunk.css";
};